export const TokenKey = {
  ETH: "eth",
  WETH: "weth",
  WSTETH: "wsteth",
  EZETH: "ezeth",
  PZETH: "pzeth",
  OPNRWA: "op-nRWA",
  NRWA: "nRWA",
  PUSD: "pUSD",
  PLUME: "plume",
  USDC: "USDC",
  USDCe: "USDCe",
} as const;

// Allow both known tokens and any custom string
export type TokenKey = (typeof TokenKey)[keyof typeof TokenKey] | string;
